export interface FoodWorksDate {
  created: string;
  lastModified: string;
}

export const DAY_IN_MILLISECONDS = 86400000;

export const getCurrentDate = (): string => new Date().toISOString();
